import { Card, CardBody, Col, Input, Label } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import Dropzone from "react-dropzone-uploader";
import { API_BASE_URL } from "../../api/api";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";

export const DataImgForm = ({
  imageFiles,
  handleImageChange,
  removeImageSlot,
  addImageSlot,
  mainImage,
  onSelectMainImage,
  imagesFromServer = [],
}) => {
  const navigate = useNavigate();

  const getUploadParams = () => ({ url: "https://httpbin.org/post" });

  const handleChangeStatus = (fileWithMeta, status, index) => {
    const { file } = fileWithMeta;

    if (status === "done") {
      const isUpdating = !!imageFiles[index];
      handleImageChange(file, index, isUpdating);
    }

    if (status === "removed") {
      confirmRemoveImage(index);
    }
  };

  const confirmRemoveImage = (index) => {
    Swal.fire({
      title: "¿Eliminar imagen?",
      text: "Despues de guardar esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        removeImageSlot(index);
        Swal.fire("Eliminada", "La imagen ha sido eliminada.", "success");
      }
    });
  };

  const allImages = imageFiles.length > 0 ? imageFiles : imagesFromServer;

  return (
    <Col xxl="12">
      <Card>
        <CardBody>
          <h5>Imágenes del producto</h5>

          {allImages.map((file, index) => {
            const isServerImage = typeof file === "string";
            const previewUrl = isServerImage
              ? `${API_BASE_URL}/product/get/file/${file}`
              : file
              ? URL.createObjectURL(file)
              : null;

            return (
              <div
                key={index}
                className="d-flex align-items-center gap-3 mb-3 p-2 border rounded bg-light"
              >
                {/* Vista previa */}
                <div
                  style={{
                    width: 80,
                    height: 80,
                    overflow: "hidden",
                    borderRadius: 8,
                    backgroundColor: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {previewUrl ? (
                    <img
                      src={previewUrl}
                      alt={`Preview ${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <span className="text-muted small text-center px-2">
                      Sin imagen
                    </span>
                  )}
                </div>

                {/* Dropzone */}
                <div style={{ flexGrow: 1 }}>
                  <Dropzone
                    getUploadParams={getUploadParams}
                    onChangeStatus={(meta, status) =>
                      handleChangeStatus(meta, status, index)
                    }
                    maxFiles={1}
                    multiple={false}
                    canCancel={false}
                    inputContent={
                      file
                        ? isServerImage
                          ? "Cambiar imagen"
                          : "Cambiar imagen"
                        : "Arrastra o selecciona imagen"
                    }
                    styles={{
                      dropzone: {
                        minHeight: 100,
                        padding: 10,
                        border: "2px dashed #6c757d",
                        borderRadius: 10,
                        backgroundColor: "#f8f9fa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      },
                      inputLabel: {
                        fontSize: 14,
                        color: "#6c757d",
                      },
                    }}
                  />
                </div>

                {/* Imagen principal */}
                <div>
                  <Label
                    className="d-flex align-items-center gap-2"
                    style={{
                      cursor: previewUrl ? "pointer" : "not-allowed",
                      fontSize: 15,
                      color: previewUrl ? "#212529" : "#adb5bd",
                    }}
                  >
                    <Input
                      type="radio"
                      name="mainImage"
                      style={{ width: 18, height: 18 }}
                      checked={mainImage == index}
                      onChange={() => onSelectMainImage(index)}
                      disabled={!previewUrl}
                    />
                    <span style={{ marginTop: 2 }}>Principal</span>
                  </Label>
                </div>

                {/* Botón Eliminar */}
                <div>
                  <Btn
                    attrBtn={{
                      color: "danger",
                      size: "sm",
                      type: "button",
                      onClick: () => confirmRemoveImage(index),
                    }}
                  >
                    <i className="fa fa-trash"></i>
                  </Btn>
                </div>
              </div>
            );
          })}

          <Btn
            attrBtn={{
              color: "info",
              size: "sm",
              type: "button",
              onClick: addImageSlot,
            }}
          >
            <i className="fa fa-plus me-2"></i> Agregar imagen
          </Btn>
        </CardBody>
      </Card>

      <div className="d-flex justify-content-end gap-2 my-3">
        <Btn
          attrBtn={{
            color: "secondary",
            type: "button",
            onClick: () => navigate(-1),
          }}
        >
          <i className="fa fa-arrow-left me-2"></i> Volver
        </Btn>

        <Btn attrBtn={{ color: "primary", type: "submit" }}>
          <i className="fa fa-save me-2"></i> Guardar Producto
        </Btn>
      </div>
    </Col>
  );
};
